var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NativeModules, Platform } from 'react-native';
import { toErrorMessage } from './ErrorHelper';
import Debug from './Debug';
import { Metric } from '../metrics';
import TENANT_ID from '../config/TenantId';
import { AZLogTenant } from '../compatibility/NativeModules/Logging/LoggingSupport';
import { LogLevel } from '../logging';
const managedConfigPropertyName = 'work_profile_manager_identifier';
const managedConfigPropertyValue = 'com.amazon.pdm.emm';
const TAG = 'MDMConfigDetectionError';
function isMDMValidForAEAAuth() {
    return __awaiter(this, void 0, void 0, function* () {
        // Web does not support step up auth or MDM
        if (Platform.OS === 'web') {
            return false;
        }
        // Since we cannot detect if we are on the right MDM for iOS, we return true by default
        if (Platform.OS === 'ios') {
            return true;
        }
        Metric('stepUpAuthMDMValidationCount', TENANT_ID).put();
        try {
            const propertyVal = yield NativeModules.ManagedConfigurationsModule
                .getManagedConfigurationPropertyValue(managedConfigPropertyName);
            if (propertyVal === managedConfigPropertyValue) {
                Debug.log('Successfully validated MDM for AEA auth');
                Metric('stepUpAuthMDMValidationSuccess', TENANT_ID).put();
                return true;
            }
            AZLogTenant(LogLevel.Info, 'Managed Config Property Value mismatch.'
                + ` Expected: ${managedConfigPropertyValue} Received: ${propertyVal}`, TENANT_ID);
            Metric('stepUpAuthMDMPropertyValueMismatch', TENANT_ID).put();
            return false;
        }
        catch (error) {
            Debug.error(TAG, 'Error occurred when validating MDM for AEA Auth', toErrorMessage(error));
            Metric('stepUpAuthMDMValidationError', TENANT_ID, {
                attributes: {
                    error: toErrorMessage(error),
                },
            }).put();
            return false;
        }
    });
}
export { managedConfigPropertyValue, isMDMValidForAEAAuth };
//# sourceMappingURL=ManagedConfigPropertyChecker.js.map